import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
} from "../../../components/card/card.jsx";
import {  useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {

  workOrder,
 
} from "../../../api/index.js";

import {
  
  formatDateOnly,
  getStatusColor,
  getRequestStatusColor,
} from "../../../utils/helper.jsx";
import { format } from "date-fns";
import DataTable from "react-data-table-component";
import ConfirmationDlg from "../../../components/ConfirmationDlg/index.jsx";
import { PermissionChecker } from "../../../components/PermissionChecker/index.jsx";



function RequestTab({ assetId }) {
  let { id } = useParams();
  if (!id) id = assetId;

  const navigate = useNavigate();
 
  const [loading, setLoading] = useState(false);

  const [deleteRow, setDeleteRow] = useState(null);
  const [query, setQuery] = useState({ page: 1, take: 10, totalData: 1 });
 
  const [datas, setDatas] = useState([]);
 
  async function getData() {
    try {
      setLoading(true);
      const queryParam = {
        ...query,
        asset_id: id,
        isRequest: true,
      };

      const res = await workOrder.list(queryParam);
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        if (data.results) {
          setDatas(data.results);
        }
        if (data.totalData) {
          setQuery((prev) => ({
            ...prev,
            totalData: data.totalData,
          }));
        }
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      toast.error(e.message);
      console.error(e);
    }
  }

  
  async function deleteData() {
    try {
      const response = await workOrder.delete(deleteRow.id);
      if (response.ok) {
        const body = await response.json();
        if (body.success) {
          toast.success("This Request has been deleted");

          setDeleteRow(null);
          await getData();
        } else {
          toast.error(body.message);
        }
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  
  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, [query.page, query.take]);

  
   const ExpandedComponent = ({ data }) => {
    return (
      <div style={{ padding: "10px" }}>
        <Card className="border-theme">
          <CardBody>
            <div className={"row"}>
              <div className="col-md-3">More detail</div>
              <div className="col-md-9">
                <div className="row">
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Asset</label>
                      <p>{data.asset?.asset_name}</p>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Category</label>
                      <p>{data.category?.name}</p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Priority</label>
                      <p>{data.priority}</p>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Submitted By</label>
                      <p>{data.created_by_user?.firstname || data.requested_by}</p>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Submitted At</label>
                      <p>
                        {format(new Date(data.created_at), "yyyy-MM-dd hh:mm")}
                      </p>
                    </div>
                  </div>

                  {data.request_status !== "Pending" && (
                    <>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label>{data.request_status} by</label>
                          <p>{data.action_taken_by_user?.firstname}</p>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label>{data.request_status} at</label>
                          <p>
                            {format(
                              new Date(data.action_taken_date),
                              "yyyy-MM-dd hh:mm"
                            )}
                          </p>
                        </div>
                      </div>
                    </>
                  )}
                </div>
                <button
                  style={{ marginRight: "10px" }}
                  onClick={() =>
                     navigate("/request/detail/" + data.id)
                  }
                  type="button"
                  className="btn btn-outline-theme"
                >
                  View Detail
                </button>

                {data.request_status == "Approved" && (
                  <button
                    style={{ marginRight: "10px" }}
                    onClick={() => navigate("/work-order/detail/" + data.id)}
                    type="button"
                    className="btn btn-outline-primary"
                  >
                    View Work Order
                  </button>
                )}

                {data.request_status == "Pending" && (
                  <>
                    <button
                      onClick={() => navigate("/request/edit/" + data.id)}
                      type="button"
                      style={{ marginRight: "10px" }}
                      className="btn btn-outline-warning"
                    >
                      <i className="fa fa-edit"></i> Edit{" "}
                      Request
                    </button>

                    <PermissionChecker permissions={["delete request"]} hideIfNotAllowed>
                    <button
                      onClick={() => showConfirmationDlg(data)}
                      type="button"
                      style={{ marginRight: "10px" }}
                      className="btn btn-outline-danger"
                    >
                      <i className="fa fa-trash"></i> Delete{" "}
                      Request
                      </button>
                      </PermissionChecker>
                  </>
                )}
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    );
  };

  let columns = [
    {
      name: "Title",
      selector: (row) => row.title,
      minWidth: "150px",
    },

    {
      name: "Category",
      selector: (row) => row.category?.name,
    },
    {
      name: "Asset",
      selector: (row) => row.asset?.asset_name,
    },
    {
      name: "Sub-Asset",
      selector: (row) => row.asset_component?.component,
    },
    {
      name: "Priority",
      selector: (row) => row.priority,
      cell: (row) => (
        <span
          className={`badge border ${
            row.priority === "high"
              ? "border-danger text-danger"
              : row.priority === "medium"
              ? "border-warning text-warning"
              : "border-success text-success"
          }`}
          style={{ textTransform: "capitalize" }}
        >
          {row.priority}
        </span>
      ),
    },
    {
      name: "Status",
      selector: (row) => row.status,
      cell: (row) => (
        <span
          className={`badge border border-${getStatusColor(
            row.status
          )} text-${getStatusColor(row.status)}`}
        >
          {row.status}
        </span>
      ),
    },
    {
      name: "Start Date",
      selector: (row) => row.start_date,
      cell: (row) => formatDateOnly(row.start_date),
    },
    {
      name: "Due Date",
      selector: (row) => row.due_date,
      cell: (row) => formatDateOnly(row.due_date),
    },
    {
      name: "Submitted By",
      selector: (row) => row.created_by_user?.firstname || row.requested_by,
    },
    {
      name: "Submitted At",
      selector: (row) => row.created_at,
      cell: (row) => formatDateOnly(row.created_at),
    },
  ];

    columns = columns.filter(
      (c) => !["Priority", "Start Date", "Due Date"].includes(c.name)
    );
    columns.splice(3, 0, {
      name: "Request Status",
      selector: (row) => row.request_status,
      cell: (row) => (
        <span
          className={`badge border border-${getRequestStatusColor(
            row.request_status
          )} text-${getRequestStatusColor(row.request_status)}`}
        >
          {row.request_status}
        </span>
      ),
    });

    columns.push({
      name: "Approved by",
      selector: (row) =>
        row.request_status == "Approved"
          ? row.action_taken_by_user?.firstname
          : "-",
    });
    columns.push({
      name: "Approved at",
      selector: (row) =>
        row.request_status == "Approved"
          ? formatDateOnly(row.action_taken_date)
          : "-",
    });

    columns.push({
      name: "Declined by",
      selector: (row) =>
        row.request_status == "Declined"
          ? row.action_taken_by_user?.firstname
          : "-",
    });
    columns.push({
      name: "Declined at",
      selector: (row) =>
        row.request_status == "Declined"
          ? formatDateOnly(row.action_taken_date)
          : "-",
    });
  

  function showConfirmationDlg(row) {
    setDeleteRow(row);
  }

  function hideConfirmationDialog() {
    setDeleteRow(null);
  }

  return (
    <div>
      

                    <div style={{ display: "flex", justifyContent: "end" }}>
                    <button
                      onClick={() => navigate("/request/add")}
                      className="btn btn-outline-theme"
                    >
                      Create Request
                    </button>
                  </div>
                  <hr />

                  <Card>
                    <CardBody>
                      <DataTable
                        progressPending={loading}
                        pointerOnHover
                        highlightOnHover
                        expandOnRowClicked
                        expandableRowsHideExpander
                        expandableRows
                        expandableRowsComponent={ExpandedComponent}
                        theme="dark"
                        columns={columns}
                        data={datas}
                        pagination
                        paginationServer
                        onChangeRowsPerPage={(row) =>
                          setQuery((prev) => ({
                            ...prev,
                            page: 1,
                            take: row,
                          }))
                        }
                        paginationTotalRows={query.totalData}
                        onChangePage={(page) =>
                          setQuery((prev) => ({ ...prev, page: page }))
                        }
                      />
                    </CardBody>
                  </Card>
       

          {deleteRow && (
            <ConfirmationDlg
              title={"Delete Request"}
              open={!!deleteRow}
              onClose={hideConfirmationDialog}
              onSubmit={deleteData}
            >
              <p style={{ pb: 2 }}>
                Are you sure you want to delete this request{" "}
                <strong>{deleteRow.title}</strong> ?
              </p>
            </ConfirmationDlg>
          )}
       
     
    </div>
  );
}

export default RequestTab;
